import ValidService from "../../../service/ValidService";
let model = {};

// dữ liệu form
model.dataForm = {
    ma: null, //string, optional // Mã huy hiệu
    co_hieu_luc: false, // boolean, optional // Cho biết huy hiệu có hiệu lực hay không
    ten: { // object, optional // Tên huy hiệu
        vi: null, //string, optional // Tên huy hiệu tiếng Việt
        en: null, //string, optional // Tên huy hiệu tiếng Anh
    },
    anh: null, // IdRef, optional // Icon đại diện của huy hiệu
    thoi_diem_tao: null, // datetime, optional // Thời điểm tạo
    nguoi_tao_id: null, // IdRef, optional // Mã người tạo
};

// validation form
model.validForm = {
    ma: [ValidService.required], //string, optional // Mã huy hiệu
    co_hieu_luc: [], // boolean, optional // Cho biết huy hiệu có hiệu lực hay không
    ten: { // object, optional // Tên huy hiệu
        vi: [ValidService.required], //string, optional // Tên huy hiệu tiếng Việt
        en: [ValidService.required], //string, optional // Tên huy hiệu tiếng Anh
    },
    anh: [], // IdRef, optional // Icon đại diện của huy hiệu
    thoi_diem_tao: [], // datetime, optional // Thời điểm tạo
    nguoi_tao_id: [], // IdRef, optional // Mã người tạo
};

// dữ liệu mẫu các form khác
model.dataFormOther = {
    fileUploadOption: {
        AnhDaiDien: {
            limit: 1,
            accept: ".jpg, .png, .jpeg",
            dialogImageUrl: "",
            dialogVisible: false,
            fileList: []
        },
    },
};

// validation các form khác
model.validFormOther = {};

model.trangThai = [{
        code: "true",
        text: "Có hiệu lực"
    },
    {
        code: "false",
        text: "Không hiệu lực"
    }
];

model.tableRules = {
    data: [],
    lengthMenu: [10, 20, 50, 100, 500],
    allowPaging: true,
    allowSorting: true,
    allowSelect: false,
    showFormSearch: false,
    showUrl: true,
    total: 0,
    page: 1,
    limit: 10,
    offset: 0,
    sort: "",
    defaultSort: ["thoi_diem_tao", "descending"],
    filters: "",
    recordSelected: [],
    dataSearch: {
        value: {
            ma: "",
            co_hieu_luc: "",
            // 'ten.vi': "",
            // 'ten.en': "",
        },
        valid: {
            ma: [],
            co_hieu_luc: [],
            // 'ten.vi': [],
            // 'ten.en': []
        },
        operator: {
            ma: ":regex_i:",
            // 'ten.vi': ":regex_i:", //:regex:, $vn_text=Viêt nam
            // 'ten.en': ":regex_i:"
        }
    }
};

export default model;